import React, { useEffect, useState } from "react";
import { Container, Navbar, Nav, Stack, Dropdown, NavDropdown } from "react-bootstrap";
import logo from "../assets/images/logo.png";
import { NavLink, useNavigate, Link } from "react-router-dom";
import { BsLayoutTextWindow, BsListTask, BsHouseDoorFill, BsCalendarMinusFill, BsBuilding, BsGraphUp, BsTable } from "react-icons/bs";
import { HiUsers } from "react-icons/hi";
import style from "./Header.module.scss";
import useAuth from "../auth/authProvider";
import { ERoles } from "../.config";
import { VscBellDot } from "react-icons/vsc";
import { FaMapMarkedAlt, FaTrain } from "react-icons/fa";
import { VscGlobe } from "react-icons/vsc";
import { VscBook, VscSymbolOperator, VscFile } from "react-icons/vsc";
import { AuxiliaryService } from "../HttpService/AuxiliaryService";
import { VscFilePdf } from "react-icons/vsc";
const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
    <a
        href=""
        ref={ref}
        onClick={e => {
            e.preventDefault();
            onClick(e);
        }}
    >
        {children}
        <span className={style.threedots} />
    </a>
));

const TODIS_HEADER_WORKFLOW = ({ permissions, frameLoaded }) => {

    //logging user here
    const navigate = useNavigate();
    const [username, setUsername] = useState("Alaa Ajlouni");
    const [userType, setUserType] = useState("Regional Partner");
    //Production
    
      const [menuDashboard, setMenuDashboard] = useState([
         { name: "TEN-T Road Network Standards Compliance", url: "https://todis.transport-community.org/portal/apps/dashboards/83bf88620c214985ba76de601c5ec2f7" },
         { name: "TEN-T Road Network Performance", url: "https://todis.transport-community.org/portal/apps/dashboards/a929119d81db42d383e3745172e7c85e" },
         { name: "Road Network Safety", url: "https://todis.transport-community.org/portal/apps/dashboards/d2488b261e9c4e378870f6a559205879" },
         { name: "Road Network Climate Resilience", url: "https://todis.transport-community.org/portal/apps/dashboards/abb6854418c44a768052112ad69515cd" },
         { name: "Roads On-Going Projects", url: "https://todis.transport-community.org/portal/apps/dashboards/65a1398d8f1243ee8a9d919934a9a560" },
         { name: "TEN-T Rail Network Standards Compliance", url: "https://todis.transport-community.org/portal/apps/dashboards/aa9143d98f91408f829a433a49c7ccdf" },
         { name: "TEN-T Rail Network Performance", url: "https://todis.transport-community.org/portal/apps/dashboards/64b7bcc164fc420ab0abeb4fbc426a57" },
         { name: "Rail Network Climate Resilience", url: "https://todis.transport-community.org/portal/apps/dashboards/5a430f17e5d44094a9c7bc852a16e77e" },
         { name: "Railways On-Going Projects", url: "https://todis.transport-community.org/portal/apps/dashboards/2efd564394b7423eb9099254b85d5c22" },
         { name: "TEN-T IWW Network Standards Compliance and Performance", url: "https://todis.transport-community.org/portal/apps/dashboards/a3361c4330e14e95bfd897890ee9b93a" },
         { name: "IWW On-Going Projects", url: "https://todis.transport-community.org/portal/apps/dashboards/ddc366480cc648478543b93a5f7e0334" },
         { name: "TEN-T Airports Compliance and Performance", url: "https://todis.transport-community.org/portal/apps/dashboards/bc2d0341b49b4ec0ad45883ca55cd270" },
         { name: "Border Crossings Performance", url: "https://todis.transport-community.org/portal/apps/dashboards/c38128bbb1e5492eabfbd0ea50994180" },
         { name: "TEN-T Ports Compliance and Performance", url: "https://todis.transport-community.org/portal/apps/dashboards/9a6911259b814419b9d806d980f41a51" },
         { name: "EU Acquis", url: "https://todis.transport-community.org/portal/apps/dashboards/a6e18e1e111d46e1bc8e5a86570db63f" }
     ]); 
    
    //Staging
    /* const [menuDashboard, setMenuDashboard] = useState([
        { name: "TEN-T Road Network Standards Compliance", url: "https://todis.transport-community.org/portal/apps/dashboards/cbe6ee1a222f4c5abdc33f6c8fd15b91" },
        { name: "TEN-T Road Network Performance", url: "https://todis.transport-community.org/portal/apps/dashboards/9ef8737779024d37a47f8d3369ca5969" },
        { name: "Road Network Safety", url: "https://todis.transport-community.org/portal/apps/dashboards/ccd510c424a942a6a5f62555c0d2cc84" },
        { name: "Roads On-Going Projects", url: "https://todis.transport-community.org/portal/apps/dashboards/965cc104d23a4a43a7ce7277cddbccd0" },
        { name: "Road Network Climate Resilience", url: "https://todis.transport-community.org/portal/apps/dashboards/abb6854418c44a768052112ad69515cd" },
        { name: "TEN-T Rail Network Standards Compliance", url: "https://todis.transport-community.org/portal/apps/dashboards/a5ec3eb662c147ac8cd6625d839b68b4" },
        { name: "TEN-T Rail Network Performance", url: "https://todis.transport-community.org/portal/apps/dashboards/1cbe52a690fa4d5195f33cb513645d81" },
        { name: "Rail Network Climate Resilience", url: "https://todis.transport-community.org/portal/apps/dashboards/5a430f17e5d44094a9c7bc852a16e77e" },
        { name: "Railways On-Going Projects", url: "https://todis.transport-community.org/portal/apps/dashboards/444ed8d81f9c4b4f843a6bd7a8f8ac94" },
        { name: "TEN-T IWW Network Standards Compliance and Performance", url: "https://todis.transport-community.org/portal/apps/dashboards/ec8019b4259b474c95745b8f0c7ef00a" },
        { name: "IWW On-Going Projects", url: "https://todis.transport-community.org/portal/apps/dashboards/a2feaefd23f64c6e833ce0aaa099fdf4" },
        { name: "TEN-T Airports Compliance and Performance", url: "https://todis.transport-community.org/portal/apps/dashboards/7276d1b2fd7943df9695d3583c6be19e" },
        { name: "Border Crossings Performance", url: "https://todis.transport-community.org/portal/apps/dashboards/f8cdf6fef36b493f93d4f2e852123028" },
        { name: "TEN-T Ports Compliance and Performance", url: "https://todis.transport-community.org/portal/apps/dashboards/afaeffeabc4a40acbbb70e4f624c2758" },
        { name: "EU Acquis", url: "https://todis.transport-community.org/portal/apps/dashboards/b24691e9c3ca40c89d55c71d953eb27a" },
    ]); */
    const { user, logout } = useAuth();

    // useEffect(() => {
    //     getDataSelect();
    // });
    const buildIcon = () => {
        return permissions.some(item => item.id == 2) ? <><BsLayoutTextWindow size="23" color="#004494" style={{ marginRight: "0.5rem" }} /> Requests</> : <><BsListTask size="23" color="#004494" style={{ marginRight: "0.5rem" }} />Tasks</>
    }


    const avatarLabel = (name) => {
        let fullname = name.replace(".", " ");
        return fullname.split(' ').map(i => i.charAt(0)).toString().toUpperCase().split(',')
    }

    return (
        <Navbar bg="white" expand="lg">
            <Container fluid className="px-4">
                <Navbar.Brand href="#"><img src="/assets/images/logo.png" alt="Transport Community" width="120" /></Navbar.Brand>
                <Navbar.Toggle aria-controls="navbarScroll" />
                <Navbar.Collapse id="navbarScroll">


                    {
                        permissions.some(item => item.id == 1 || item.id == 3 || item.id == 6 || item.id == 2 || item.id == 5) ?
                            <Nav
                                className="me-auto my-2 my-lg-0"
                                style={{ maxHeight: '100px' }}
                                navbarScroll
                            >
                                {/* <Nav.Item as="li" style={{ paddingRight: "15px" }}>
                                    <NavLink to="/Admin/" className={(navData) =>
                                        navData.isActive
                                            ? style.active
                                            : style.notActive
                                    }><BsHouseDoorFill size="23" color="#004494" style={{ marginRight: "0.5rem" }} /> Home</NavLink>
                                </Nav.Item>
                                <Nav.Item as="li" style={{ paddingRight: "15px" }}>
                                    <NavLink to="/Admin/Users"
                                        className={(navData) =>
                                            navData.isActive
                                                ? style.active
                                                : style.notActive
                                        }><HiUsers size="23" color="#004494" style={{ marginRight: "0.5rem" }} /> Users</NavLink>
                                </Nav.Item>
                                <Nav.Item as="li" style={{ paddingRight: "15px" }}>
                                    <NavLink to="/Admin/Organitzations"
                                        className={(navData) =>
                                            navData.isActive
                                                ? style.active
                                                : style.notActive
                                        }><BsBuilding size="23" color="#004494" style={{ marginRight: "0.5rem" }} /> Organizations</NavLink>
                                </Nav.Item>
                                <Nav.Item as="li" style={{ paddingRight: "15px" }}>
                                    <NavLink to="/Admin/History"
                                        className={(navData) =>
                                            navData.isActive
                                                ? style.active
                                                : style.notActive
                                        }><BsCalendarMinusFill size="23" color="#004494" style={{ marginRight: "0.5rem" }} /> History</NavLink>
                                </Nav.Item> */}

                                {
                                    permissions.some(item => item.id == 2) &&
                                    <Nav.Item as="li" style={{ paddingRight: "15px" }}>
                                        <NavLink to="/TODIS-APP/WorkFlow/tasks"
                                            className={(navData) =>
                                                navData.isActive
                                                    ? style.active
                                                    : style.notActive
                                            }
                                        ><BsListTask size="23" color="#004494" style={{ marginRight: "0.5rem" }} />
                                            Tasks
                                        </NavLink>
                                    </Nav.Item>
                                }
                                <Nav.Item as="li" style={{ paddingRight: "15px" }}>
                                    <NavLink to="/TODIS-APP/WorkFlow/" className={(navData) =>
                                        navData.isActive
                                            ? style.active
                                            : style.notActive
                                    }>{buildIcon()}</NavLink>
                                </Nav.Item>
                                <Nav.Item as="li" style={{ paddingRight: "15px" }}>
                                    <NavLink to="/TODIS-APP/WorkFlow/notifications"
                                        className={(navData) =>
                                            navData.isActive
                                                ? style.active
                                                : style.notActive
                                        }><VscBellDot size="23" color="#004494" style={{ marginRight: "0.5rem" }} /> Notifications</NavLink>
                                </Nav.Item>
                                <Nav.Item as="li" style={{ paddingRight: "15px" }}>
                                    <NavLink to="/TODIS-APP/DataSharing"
                                        className={(navData) =>
                                            navData.isActive
                                                ? style.active
                                                : style.notActive
                                        }><FaMapMarkedAlt size="23" color="#004494" style={{ marginRight: "0.5rem" }} /> Data Sharing</NavLink>
                                </Nav.Item>
                                {user.permissions.some(item => item.id == 8) && (
                                    <NavDropdown className={style.dropdown}
                                        title={<div style={{ display: "inline-block" }}><BsGraphUp size="23" color="#004494" style={{ marginRight: "0.5rem" }} /> Dashboard </div>} style={{ paddingRight: "15px" }}>
                                        {
                                            menuDashboard.map((item, index) => {
                                                return (<NavDropdown.Item key={index} onClick={() => navigate("/TODIS-APP/Dashboard", { state: { url: item.url, id: ("dashboard" + "-" + index), name: item.name } })}>{item.name} </NavDropdown.Item>)
                                            })
                                        }
                                    </NavDropdown>
                                )}
                                {user.permissions.some(item => item.id === 1 && item.permissions.some(subItem => subItem.id === 0)) && (
                                    <Nav.Item as="li" style={{ paddingRight: "15px" }}>
                                        <NavLink to="/TODIS-APP/EUAcquis"
                                            className={(navData) =>
                                                navData.isActive
                                                    ? style.active
                                                    : style.notActive
                                            }><VscGlobe size="23" color="#004494" style={{ marginRight: "0.5rem" }} /> EU Acquis </NavLink>
                                    </Nav.Item>
                                )}

                                <Nav.Item as="li" style={{ paddingRight: "15px" }}>
                                        <NavLink to="/TODIS-APP/RMM" className={(navData) =>
                                                navData.isActive
                                                    ? style.active
                                                    : style.notActive
                                            }>
                                            <FaTrain size="23" color="#004494" style={{ marginRight: "0.5rem" }} />
                                            Railway Market Monitoring
                                        </NavLink>
                                    </Nav.Item>

                                <Nav.Item as="li" style={{ paddingRight: "15px" }}>
                                    <NavLink to="/TODIS-APP/UserManual"
                                        className={(navData) =>
                                            navData.isActive
                                                ? style.active
                                                : style.notActive
                                        }>
                                        <VscBook size="23" color="#004494" style={{ marginRight: "0.5rem" }} />
                                        User Manual
                                    </NavLink>
                                </Nav.Item>

                                <Nav.Item as="li" style={{ paddingRight: "15px" }}>
                                    <NavLink to="/TODIS-APP/Export"
                                        className={(navData) =>
                                            navData.isActive
                                                ? style.active
                                                : style.notActive
                                        }>
                                        <VscFile size="23" color="#004494" style={{ marginRight: "0.5rem" }} />
                                        Export
                                    </NavLink>
                                </Nav.Item>

                                <Nav.Item as="li" style={{ paddingRight: "15px" }}>

                                <NavLink
                                    to="/TODIS-APP/ProjectModule"
                                    className={(navData) =>
                                    navData.isActive
                                        ? style.active
                                        : style.notActive
                                    }
                                >
                                    <BsTable size="23" color="#004494" style={{ marginRight: "0.5rem" }} />
                                    Project Module
                                </NavLink>
                                </Nav.Item>

                                {/* <Nav.Item as="li" style={{ paddingRight: "15px" }}>
                                    <NavLink to="/TODIS-APP/FormulaBuilder"
                                        className={(navData) =>
                                            navData.isActive
                                                ? style.active
                                                : style.notActive
                                        }>
                                        <VscSymbolOperator size="23" color="#004494" style={{ marginRight: "0.5rem" }} />
                                        Formula Builder
                                    </NavLink>
                                </Nav.Item> */}


                            </Nav> :
                            <Nav
                                className="me-auto my-2 my-lg-0"
                                style={{ maxHeight: '100px' }}
                                navbarScroll
                            >
                                {/* <Nav.Item as="li" style={{ paddingRight: "15px" }}>
                                    <NavLink to="/Admin/" className={(navData) =>
                                        navData.isActive
                                            ? style.active
                                            : style.notActive
                                    }><BsHouseDoorFill size="23" color="#004494" style={{ marginRight: "0.5rem" }} /> Home</NavLink>
                                </Nav.Item> */}
                                <Nav.Item as="li" style={{ paddingRight: "15px" }}>
                                    <NavLink to="/TODIS-APP/Admin/Users"
                                        className={(navData) =>
                                            navData.isActive
                                                ? style.active
                                                : style.notActive
                                        }><HiUsers size="23" color="#004494" style={{ marginRight: "0.5rem" }} /> Users</NavLink>
                                </Nav.Item>
                                <Nav.Item as="li" style={{ paddingRight: "15px" }}>
                                    <NavLink to="/TODIS-APP/Admin/Organizations"
                                        className={(navData) =>
                                            navData.isActive
                                                ? style.active
                                                : style.notActive
                                        }><BsBuilding size="23" color="#004494" style={{ marginRight: "0.5rem" }} /> Organizations</NavLink>
                                </Nav.Item>
                                {/* <Nav.Item as="li" style={{ paddingRight: "15px" }}>
                                    <NavLink to="/TODIS-APP/Admin/History"
                                        className={(navData) =>
                                            navData.isActive
                                                ? style.active
                                                : style.notActive
                                        }><BsCalendarMinusFill size="23" color="#004494" style={{ marginRight: "0.5rem" }} /> History</NavLink>
                                </Nav.Item> */}
                            </Nav>


                    }






                    <Navbar>

                        <Stack direction="horizontal" gap={3} className="todis-profile-section">
                            <div className={style.avatar}>{avatarLabel(user.username)}</div>
                            <Stack className="todis-profile-name">
                                <strong>{user.username}</strong>
                                <small className={`${style.profileUserType} ${"text-muted"}`}>{ERoles[user.roles[0]]?.label || user.roles[0]}</small>
                            </Stack>
                            <Dropdown drop="start">
                                <Dropdown.Toggle as={CustomToggle} />
                                <Dropdown.Menu size="sm" title="">
                                    {/* <Dropdown.Header>Options</Dropdown.Header> */}
                                    <Dropdown.Item as={Link} to="/TODIS-APP/Profile">My Profile</Dropdown.Item>
                                    <Dropdown.Item as={Link} to="/TODIS-APP/ChangePassword">Change password</Dropdown.Item>
                                    {permissions.some(item => item.id == 2 || item.id == 7) && <Dropdown.Item as={Link} to="/TODIS-APP/GroupNotification">Group Notifications</Dropdown.Item>}
                                    <Dropdown.Item onClick={logout}>Sign out</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </Stack>
                    </Navbar>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    )
}

export default TODIS_HEADER_WORKFLOW; 